import { render, staticRenderFns } from "./columnChartTax.vue?vue&type=template&id=37f472c6"
import script from "./columnChartTax.vue?vue&type=script&lang=js"
export * from "./columnChartTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports